import React, { useEffect, useState } from 'react'
import Button from "../../extras/Button";
import Input, { ExInput } from "../../extras/Input";
import { useDispatch, useSelector } from "react-redux";
import { editData, objectToFormData, submitData } from "../../../util/fuction";
import { closeDialog } from "../../../redux/slice/dialogueSlice";
import { DangerRight } from '../../api/toastServices';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { rescheduleBooking } from '../../../redux/slice/bookingSlice';
import { blockDailySlot, unblockDailySlot } from '../../../redux/slice/expertSlice';

const StuffBusySlotDialogue = () => {
    const dispatch = useDispatch();
    const { dialogueData } = useSelector((state) => state.dialogue);

    const [s_fname, setSFname] = useState("");
    const [s_lname, setSLname] = useState("");
    const [s_email, setSEmail] = useState("");
    const [s_mobile, setSMobile] = useState("");
    const [startTime, setStartTime] = useState();
    const [endTime, setEndTime] = useState();
    const [date, setDate] = useState();


    useEffect(() => {
        if (dialogueData) {
            console.log(dialogueData);
            editData(dialogueData);

            setSFname(dialogueData?.expert?.fname);
            setSLname(dialogueData?.expert?.lname);
            setSEmail(dialogueData?.expert?.email);
            setSMobile(dialogueData?.expert?.mobile);
            if (dialogueData?.start) {
                // Parse the time string "HH:mm:ss" and create a Date object
                const timeParts = dialogueData.start.split(':');
                const timeDate = new Date();
                timeDate.setHours(parseInt(timeParts[0], 10));
                timeDate.setMinutes(parseInt(timeParts[1], 10));
                timeDate.setSeconds(parseInt(timeParts[2] || 0, 10));
                setStartTime(timeDate);
            }
            if (dialogueData?.end) {
                // Parse the time string "HH:mm:ss" and create a Date object
                const timeParts = dialogueData.end.split(':');
                const timeDate = new Date();
                timeDate.setHours(parseInt(timeParts[0], 10));
                timeDate.setMinutes(parseInt(timeParts[1], 10));
                timeDate.setSeconds(parseInt(timeParts[2] || 0, 10));
                setEndTime(timeDate);
            }
            // setStartTime(dialogueData?.start);
            // setEndTime(dialogueData?.end);
            setDate(dialogueData?.date);
        }
    }, [dialogueData]);
    const handleSubmitBlock = async (e) => {
        e.preventDefault();

        const formDataJson = {
            time: moment(startTime).format("HH:mm") + ',' + moment(endTime).format("HH:mm"),
            date: date,
            expert_id: dialogueData?.expert?.id,
            _method: 'post',
        };
        try {
            // let response;
            dispatch(blockDailySlot(formDataJson))
                .then((res) => {
                    console.log(res);
                    if (res.payload.status) {
                        dispatch(closeDialog());
                    } else {
                        DangerRight(res.message);
                    }
                })
                .catch((err) => {
                    console.error("Error:", err);
                    DangerRight(err.message || "Something went wrong");
                });
        } catch (err) {
            console.log("err", err);
            DangerRight(err.message);
        }

    };


    const handleSubmitUnBlock = async (e) => {
        // console.log(e);
        e.preventDefault();

        const formDataJson = {
            start_time: startTime ? moment(startTime).format("HH:mm") : null,
            end_time: endTime ? moment(endTime).format("HH:mm") : null,
            // start_time: startTime,
            // end_time: endTime,
            date: date,
            expert_id: dialogueData?.expert?.id,
            _method: 'post',
        };
        try {
            // let response;
            dispatch(unblockDailySlot(formDataJson))
                .then((res) => {
                    console.log(res);
                    if (res.payload.status) {
                        dispatch(closeDialog());
                    } else {
                        DangerRight(res.message);
                    }
                })
                .catch((err) => {
                    console.error("Error:", err);
                    DangerRight(err.message || "Something went wrong");
                });
        } catch (err) {
            console.log("err", err);
            DangerRight(err.message);
        }

    };
    return (

        <div className="dialog">
            <div class="w-100">
                <div class="row justify-content-center">
                    <div class="col-xl-5 col-md-8 col-11">
                        <div class="mainDiaogBox">
                            <div class="row justify-content-between align-items-center formHead">
                                <div className="col-8">
                                    <h2 className="text-theme m0">Stuff Busy Slot</h2>
                                </div>
                                <div className="col-4">
                                    <div
                                        className="closeButton"
                                        onClick={() => {
                                            dispatch(closeDialog());
                                        }}
                                    >
                                        <i className="ri-close-line"></i>
                                    </div>
                                </div>
                            </div>
                            <div className="row align-items-start formBody">
                                <hr ></hr>
                                <h4>Staff Info: </h4>
                                <div className="col-12 col-md-6">
                                    <p><strong>Name:</strong> {s_fname + ' ' + s_lname}</p>
                                </div>
                                <div className="col-12 col-md-6">
                                    <p><strong>Email</strong> {s_email}</p>
                                </div>
                                <div className="col-12 col-md-6">
                                    <p><strong>Mobile</strong> {s_mobile}</p>
                                </div>
                                <hr></hr>

                                <div className="col-12">
                                    <label htmlFor="date" className="mb-1">Date</label>
                                    <br></br>
                                    <DatePicker
                                        id="date"
                                        name="date"
                                        selected={date ? new Date(date) : null}
                                        onChange={(date) => setDate(date ? date.toISOString().split("T")[0] : "")}
                                        className="form-control w-full"
                                        placeholderText="Select Date"
                                        dateFormat="yyyy-MM-dd"
                                    />
                                </div>

                                <div className="col-12 col-md-6">
                                    <label className="d-block mb-2">Start Time</label>
                                    <DatePicker
                                        selected={startTime}
                                        onChange={setStartTime}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={15}
                                        timeCaption="Time"
                                        dateFormat="HH:mm"
                                        className="form-control w-full"
                                        placeholderText="Select Time"
                                        timeFormat="HH:mm"

                                    />
                                    {/* <ExInput
                                        type={`time`}
                                        value={startTime}
                                        id={`startTime`}
                                        name={`startTime`}
                                        label={`Start Time`}
                                        placeholder={`Start Time`}
                                        onChange={(e) => {
                                            console.log(e.target.value);
                                            setStartTime(e.target.value);
                                            console.log(startTime);
                                        }}
                                    /> */}
                                </div>
                                <div className="col-12 col-md-6">
                                    <label className="d-block mb-2">End Time</label>
                                    <DatePicker
                                        selected={endTime}
                                        onChange={setEndTime}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={15}
                                        timeCaption="Time"
                                        dateFormat="HH:mm"
                                        className="form-control w-full"
                                        placeholderText="Select Time"
                                        timeFormat="HH:mm"

                                    />

                                    {/* <ExInput
                                        type={`time`}
                                        value={endTime}
                                        id={`endTime`}
                                        name={`endTime`}
                                        label={`End Time`}
                                        placeholder={`End Time`}
                                        onChange={(e) => {
                                            console.log(e.target.value);
                                            setEndTime(e.target.value);
                                            // console.log(startTime);
                                        }}
                                    /> */}
                                </div>


                            </div>
                            <div className="row  formFooter">
                                <div className="col-12 text-end m">
                                    <Button className={`bg-gray text-light`} text={`Cancel`} type={`button`} onClick={() => dispatch(closeDialog())} />
                                    <Button className={`bg-gray text-light m10-left`} text={`Un Block`} type={`button`} onClick={(e) => handleSubmitUnBlock(e)} />
                                    <Button
                                        type={`button`}
                                        className={`bg-theme text-light m10-left`}
                                        text={`Update`}
                                        onClick={(e) => handleSubmitBlock(e)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StuffBusySlotDialogue;
